import { NavLink, NavLinkProps } from 'theme-ui';

import Icon, { IconName, IconProps } from '../Icon';

export interface IconNavLinkProps extends NavLinkProps {
  icon: IconName;
  iconProps?: Omit<IconProps, 'icon'>;
}

const IconNavLink: React.FC<IconNavLinkProps> = ({ icon, iconProps, ...props }) => (
  <NavLink {...props}>
    <Icon icon={icon} {...iconProps} />
  </NavLink>
);

IconNavLink.defaultProps = {
  variant: 'links.icon',
  iconProps: {
    width: 24,
    height: 24
  }
};

export default IconNavLink;
